import React from "react";
import WeeklyGridBar from "./components/WeeklyGridBar";
import WeeklyGridTable from "./components/WeeklyGridTable";
import CourtReservationModal from "../CourtGrid/components/CourtReservationModal";
import EASkeletonLoader from "../shared/EASkeletonLoader";
import useWeeklyGrid from "./useWeeklyGrid";
import { SaleStep } from "../../store/stepSaleConfig/stepSaleConfigReducer";
import EAAlert from "../shared/EAAlert";
import "./style.scss";

interface IProps {
  saleStep: SaleStep;
}

const WeeklyGrid: React.FC<IProps> = ({ saleStep }) => {
  // Wyciągnij nazwę kortu z exerciseName (pierwsza nazwa jeśli kilka)
  const courtName = saleStep.exerciseName?.split(";")[0].trim() || "";

  const {
    weeklyGridData,
    loading: dataLoading,
    startDate,
    setStartDate,
    reservationModal,
    uniqueHours,
    findSlot,
    getSlotStatus,
    getSlotsForHour,
    refetchWeeklyData,
    handleSlotClick,
    handleCloseReservationModal,
    handlePreviousPeriod,
    handleNextPeriod,
    handleTicketAdded,
  } = useWeeklyGrid(courtName);

  if (dataLoading && weeklyGridData.length === 0) {
    return <EASkeletonLoader height="400px" />;
  }

  return (
    <div className="weekly-grid-container">
      <WeeklyGridBar
        startDate={startDate}
        onPreviousPeriod={handlePreviousPeriod}
        onNextPeriod={handleNextPeriod}
        onDateChange={setStartDate}
        courtName={courtName}
      />

      {dataLoading ? (
        <EASkeletonLoader height="400px" />
      ) : weeklyGridData.length === 0 ? (
        <EAAlert type="error" message="Nie udało się załadować danych dla wybranego okresu." />
      ) : (
        <WeeklyGridTable
          weeklyGridData={weeklyGridData}
          allHours={uniqueHours}
          findSlot={findSlot}
          getSlotStatus={getSlotStatus}
          onSlotClick={handleSlotClick}
          getSlotsForHour={getSlotsForHour}
          saleStep={saleStep}
          onPreviousPeriod={handlePreviousPeriod}
          onNextPeriod={handleNextPeriod}
          startDate={startDate}
        />
      )}

      <CourtReservationModal
        isOpen={reservationModal.isOpen}
        onClose={handleCloseReservationModal}
        exerciseId={reservationModal.exerciseId}
        saleStep={saleStep}
        onTicketAdded={handleTicketAdded}
        onDataRefresh={refetchWeeklyData}
      />
    </div>
  );
};

export default WeeklyGrid;

